import classNames from 'classnames/bind';
import React from 'react';

import {
    CheckboxAdvanced,
    CheckboxAdvancedProps,
} from 'reactComponents/CheckboxAdvanced/CheckboxAdvanced';

import styles from './CheckboxGroup.css';

const css = classNames.bind(styles);

type CheckboxValue = CheckboxAdvancedProps['value'];

export type CheckboxGroupOption = {
    label: React.ReactNode;
    value: CheckboxValue;
} & Omit<Partial<CheckboxAdvancedProps>, 'label' | 'value'>;

export type CheckboxGroupProps = {
    options: CheckboxGroupOption[];
    value: CheckboxValue[];
    onChange?(
        event: React.FormEvent<HTMLInputElement>,
        props: CheckboxGroupProps,
    ): void;
    columnCount?: number;

    // you can pass groups of values, that cannot be checked together
    // if one element of group is cheked, than another group's element is disabled
    antagonistGroups?: [CheckboxValue[], CheckboxValue[]][];
};

export class CheckboxGroup extends React.PureComponent<CheckboxGroupProps> {
    renderCheckbox = (params: CheckboxGroupOption) => {
        return (
            <CheckboxAdvanced
                {...params}
                className={css('checkbox')}
                key={params.value}
                checked={this.getIsChecked(params)}
                onChange={this.handleChange}
                disabled={
                    params.disabled || this.getIsAntagonistChecked(params.value)
                }
            />
        );
    };

    getIsAntagonistChecked = (value: CheckboxValue) => {
        return this.props.antagonistGroups?.some(([a, b]) => {
            if (a.includes(value)) {
                return b.some((item) => this.props.value.includes(item));
            } else if (b.includes(value)) {
                return a.some((item) => this.props.value.includes(item));
            }
            return false;
        });
    };

    handleChange = (
        event: React.FormEvent<HTMLInputElement>,
        data: CheckboxAdvancedProps,
    ) => {
        const value = data.checked
            ? this.props.value.concat(data.value)
            : this.props.value.filter((item) => item !== data.value);
        this.props.onChange &&
            this.props.onChange(event, { ...this.props, value });
    };

    getIsChecked = (params: CheckboxGroupOption) => {
        return this.props.value.includes(params.value);
    };

    render() {
        return (
            <div
                className={css('root')}
                style={{ columnCount: this.props.columnCount }}
            >
                {this.props.options.map(this.renderCheckbox)}
            </div>
        );
    }
}
